import axios from "axios";
import { BoUser } from "models/BO/BoUser";
import { makeRequest, networkGlobals } from "./networkUtils";
import { Brand } from "models/BO/Brand";
import { camelcaseToSnakeCase } from "./globalsUtils";
import { BoSession } from "models/BO/BoSession";

/** get list of settings */
export const getSystemUsersDO = async (brandID?, page?, matchmakers?, showAll=false): Promise<BoUser[]> => {
  return makeRequest(`system-users?page=${page}&matchmakers=${matchmakers}&showAll=${showAll}`, {
    brandId: brandID,
  }).then((data) => data.map((user) => Object.assign(new BoUser(), user)));
};

export const deleteEndUserDO = async (userID) => {
  return makeRequest(`system-users/${userID}`, { method: "DELETE" });
};

/** get list of settings */
export const getSystemUserByIDDO = async (userID): Promise<BoUser> => {
  return makeRequest(`system-users/${userID}`);
};


/** post new user */
export const postNewUserDO = async ( data) => {
  const { avatar, ...withoutAvatar } = data;
  return makeRequest(`system-users`, { method: "POST", body: withoutAvatar });
};

/** update user */
export const updateUserDO = async (data) => {
  const { avatar, ...withoutAvatar } = data;
  return makeRequest(`system-users/${data.id}`, { method: "PUT", body: withoutAvatar });
};
export const getUsersStatsDO = async (brandID): Promise<any> => {
  return makeRequest(`system-users/stats?brandID=${brandID || ""}`);
};

/** get sessions for a system user */
export const getSystemUserSessionsDO = async (userID: string) => {
  return makeRequest(`system-users/${userID}/sessions`).then((data) =>
    data.map((session) => Object.assign(new BoSession(), session))
  );
};
